import { Navigate, Route, Routes, useParams } from "react-router-dom";
import { NotFound, PartnerLayout } from "partner/Gs1";
import {
  Auth0,
  CompanyData as CompanyDataPartner,
  Create as CreateAccountPartner,
  Forgot as ForgotPartner,
  Login as LoginPartner,
  NewPassword,
  SalesChannels as SalesChannelsPartner,
  UserData as UserDataPartner,
  UserEmail as UserEmailPartner
} from "partner/Gs1/views/Account";

const PartnerRoutes = () => {
  const { partner } = useParams();

  return (
    <PartnerLayout>
      <Routes>
        <Route path="auth0" element={<Auth0 />} />
        <Route path="companyData" element={<CompanyDataPartner />} />
        <Route path="create" element={<CreateAccountPartner />} />
        <Route path="forgot" element={<ForgotPartner />} />
        <Route path="login" element={<LoginPartner />} />
        <Route path="salesChannels" element={<SalesChannelsPartner />}  />
        <Route path="newPassword/:token" element={<NewPassword />} />
        <Route path="notFound" element={<NotFound />} />
        <Route path="userData" element={<UserDataPartner />} />
        <Route path="userEmail" element={<UserEmailPartner />} />
        <Route path="*" element={
          <Navigate to={`/partner/${partner}/notFound`} replace={true} />
        }/>
      </Routes>
    </PartnerLayout>
  );
};

export default PartnerRoutes;
